import {AxiosResponse} from 'axios';
import request from '@/request';


/**
 * 企业管理权限接口
 * @param projectId 项目id
 * @param actorId 用户id
 */
interface MergedPoliciesListParam {
  projectId: string;
  actorId: string;
}
export function mergedPoliciesListApi({projectId, actorId}: MergedPoliciesListParam) {
    return request.get('/idgate/v1/user/mergedPolicies', {
        params: {
            psId: 'default_ps',
            projectId,
            actorType: 'USER',
            actorId,
            mergeBy: 'RESOURCE',
            pageNo: 1,
            pageSize: 10,
        },
    });
}


/**
 * 查询当前企业自定义信息
 * yapi http://yapi.baidu-int.com/mock/4034/idgate/v1/project/customEnterpriseInfo
 *  */
export interface CustomEnterpriseInfoResultParams{
  enterpriseIconUrl: string;
  backgroundIconUrl: string;
  enterpriseName: string;
  enterpriseTel: string;
  enterpriseUrl: string;
  enterpriseAddress: string;
  enterpriseComment: string;
}
export function customEnterpriseInfo(): Promise<AxiosResponse<CustomEnterpriseInfoResultParams>> {
    return request.get('/idgate/v1/project/customEnterpriseInfo');
}

// 获取项目中配置的文案
export enum EIdgateV1ProjectTextMapType {
  GIF='GIF',
  CSS='CSS',
  JS='JS',
  HTML='HTML',
  PNG='PNG',
  JPEG='JPEG',
  STRING='string'
}
export interface IIdgateV1ProjectTextMapResponse {
  // result中的属性名就是文本的key，属性值就是文本的值，示例看备注
  [key: string]: any;
}
export function idgateV1ProjectTextMap(): Promise<IIdgateV1ProjectTextMapResponse> {
    return request.get('/idgate/v1/project/textMap');
}
